// extracted by mini-css-extract-plugin
export var actionButton = "_bi-0";
export var attachmentLine = "_bi-1";
export var fileInput = "_bi-2";
export var fileUploadWrapper = "_bi-4";
export var footer = "_bi-3";
export var modalContent = "_bi-5";
export var paperclip = "_bi-6";
export var quillEditor = "_bi-7";